<template>
  <router-view></router-view>
</template>

<script>
    export default {
        name: "avukat"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Icra/avukat.vue